/* Context */
import { useEffect, useContext } from 'react'
import ApiContext from 'src/ApiContext'
import { AppContext } from 'src/AppContext'

/* Types */
import { isApiResponse } from 'src/types/response'
import { isLoginResponse } from 'src/shared/apiBackendResponses/login'

const AutoLogin:React.FC = () => {
  const api = useContext(ApiContext)
  const { appState:{user}, appDispatch } = useContext(AppContext)

  const loginRefrech = async () => {
    if (user) api.socket.emit('login', user, (resUser: unknown) => {
      if (
        !isApiResponse(resUser)
        || !isLoginResponse(resUser.response)
        || resUser.response === false
      ) {
        appDispatch({ type: 'LOGOUT' })
        return
      }
      if ( !resUser.response.rights.every((r, i) => r === user.rights[i]) )
        appDispatch({ type: 'RIGHTS', payload: resUser.response.rights })
    })
  }

  useEffect(() => {
    loginRefrech()

    api.socket.on('rights', (rights: unknown) => {
      if ( Array.isArray(rights) && rights.every((r): r is string => typeof r === 'string') )
        appDispatch({ type: 'RIGHTS', payload: rights })
    })

    api.socket.io.on('reconnect',() => {
      loginRefrech()
    })

    return () => { api.socket.off('rights') }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return null

}

export default AutoLogin